import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import AppBar from "@mui/material/AppBar";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Table from "../offers/Table";
import CloseIcon from "@mui/icons-material/Close";

export default function CollectionDetails(props) {
	//  const host="${process.env.REACT_APP_BASE_URL_VMS}  ";
	const { open, setOpen, collectionDetails } = props;

	const rows = collectionDetails && collectionDetails.map((collection) => ({
		id: collection.co_id,
		collection_name: collection.collection_name,
		brand_name: collection.brand_name,
		type: collection.type,
		collection_details: collection.collection_details,
		offering_details: collection.offfer_details,
	}));
	const columns = [
		{ field: "id", headerName: "ID", width: 50 },
		{
			field: "collection_name",
			headerName: "Collection Name",
			width: 160,
			editable: false,
		},
		{
			field: "collection_details",
			headerName: "Collection Details",
			width: 150,
			editable: false,
		},
		{
			field: "brand_name",
			headerName: "Brand Name",
			width: 150,
			editable: false,
		},
		{
			field: "type",
			headerName: "Type",
			width: 150,
			editable: false,
		},
		{
			field: "offering_details",
			headerName: "Offering Details",
			width: 150,
			editable: false,
		},
	];
	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<div>
			<Dialog
				fullWidth
				maxWidth='lg'
				scroll='paper'
				open={ open }
				onClose={ handleClose }
				PaperProps={{
					sx: {
						borderRadius: 3,
						overflow: "hidden",
						maxHeight: "92vh",
						border: "1px solid rgba(148, 163, 184, 0.35)",
						background: "#ffffff",
					},
				}}
				BackdropProps={{
					sx: {
						backdropFilter: "blur(6px)",
						backgroundColor: "rgba(2, 6, 23, 0.6)",
					},
				}}
			>
				<AppBar
					sx={{
						position: "relative",
						background:
							"linear-gradient(90deg, #1d4ed8 0%, #2563eb 50%, #06b6d4 100%)",
					}}
				>
					<Toolbar>
						<Typography sx={{ ml: 2, flex: 1 }} variant='h6' component='div'>
							Collection Details
						</Typography>
						<IconButton edge='end' color='inherit' onClick={handleClose} aria-label='close'>
							<CloseIcon />
						</IconButton>
					</Toolbar>
				</AppBar>
				<DialogContent dividers sx={{ p: 2, overflowY: "auto", maxHeight: "calc(92vh - 64px)" }}>
					<Table rows={ rows } columns={ columns } />
				</DialogContent>
				<DialogActions sx={{display:"flex",justifyContent:"center"}}>
					<Button onClick={ handleClose } variant="contained" sx={{background:"red","&:hover":{background:"red"}}}>Close</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}
